import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

export const Table = styled.div`
  .react-bootstrap-table {
    
    .table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 0;

      tr {
        border: none;
      }

      td {
        padding: 0;
      }

      thead {
        th {
          vertical-align: unset;
        }
      }
    }
    ${({ scroll }) => scroll && getScroll()}
  }

  .headerClasses {
    th {
      padding: ${theme.spacing['spacing-5']};
      background-color: ${theme.colors.neutral.bg.strong};
      
    }
  }


  tbody {
    tr {
      box-shadow: inset 0 -1px 0 ${theme.colors.neutral.border.weak};
      height: 48px;

      ${({ clickableRows }) =>
        clickableRows
          ? `
        &:hover {
          cursor: pointer;
          background-color: ${theme.colors.neutral.bg.regular} !important;
          box-shadow: inset 0 -1px 0 ${theme.colors.neutral.border.regular};
        }
  
        &:active {
          background-color: ${theme.colors['secondary-1'].bg.weak} !important;
          box-shadow: inset 0 -1px 0 ${theme.colors['secondary-1'].border.regular};
        }`
          : `        
        &:hover {
           background-color: ${theme.colors.neutral.bg.regular} !important;
           box-shadow: inset 0 -1px 0 ${theme.colors.neutral.border.regular};
        }`}
    }

    td {
      vertical-align: middle;
      padding-left: ${theme.spacing['spacing-5']} !important;
      padding-right: ${theme.spacing['spacing-5']} !important;
      ${theme.textStyles['text-preset-10']()}
      &.react-bs-table-no-data {
        text-align: center;
      }
    }
  }
}

.react-bootstrap-table-pagination {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  padding: ${theme.spacing['spacing-6']};
  ${theme.textStyles['text-preset-10']()};

  .pagination__total {
    text-align: center;
    color: ${theme.colors.neutral.text.regular};
  }

  .pagination__list-of-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.neutral.text.strong};

    .pagination-list-of-buttons__button {
    @extend . pagination__total;
      font: inherit;
      cursor: pointer;
      background: none;
      color: inherit;
      border: none;
      outline: none;
      padding: 0;
      height: 28px;
      width: 28px;
      margin-right: ${theme.spacing['spacing-4']};

      &:hover {
        background-color: ${theme.colors.neutral.bg.regular};
        border-radius: ${theme.borderRadius['border-radius-5']};

        svg {
          path {
            fill: ${theme.colors.primary.ic.strong};
          }
        }
      }

      &:active {
        svg {
          path {
            fill: ${theme.colors['secondary-1'].ic.strong};
          }
        }
      }

      &:first-child,
      &:nth-child(2),
      &:last-child,
      &:nth-last-child(2) {
        background-color: transparent;
      }
    }

    .page--active {
      color: ${theme.colors.neutral.text.inverted};
      background-color: ${theme.colors['secondary-1'].bg.regular};
      border-radius: ${theme.borderRadius['border-radius-5']};

      &:hover {
        color: ${theme.colors.neutral.text.inverted};
        background-color: ${theme.colors['secondary-1'].bg.strong};
      }
    }

    .page--active-pill {
    @extend . page--active;
      height: auto;
      width: auto;
    }
  }
}
`;

const getScroll = () => css`
  @media (max-width: ${theme.breakpoints['s'].max}) {
    .table {
      width: 100vw;
      table-layout: auto;
    }
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: ${theme.colors['neutral'].border}
      ${theme.colors['neutral'].bg.weak};

    &::-webkit-scrollbar {
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${theme.colors['neutral'].bg.weak};
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors['neutral'].bg.stronger};
      height: 24px;
      border-radius: ${theme.borderRadius['border-radius-5']};
      margin: ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']}
        ${theme.spacing['spacing-0']};
      padding: ${theme.spacing['spacing-6']} ${theme.spacing['spacing-13']}
        ${theme.spacing['spacing-5']} ${theme.spacing['spacing-12']};
    }
  }
`;
